import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'map/geo-digitaltwin'
  },
  {
    // DO NOT REMOVE - Support old path from old QR Codes
    path: 'pages/digitaltwin',
    redirectTo: 'digitaltwin',
    pathMatch: 'full',
    data: { preserveQueryParams: true }
  },
  {
    path: 'digitaltwin',
    loadChildren: () => import('./digital-twin/digital-twin.module').then((m) => m.DigitalTwinModule),
  },
  {
    path: 'map',
    loadChildren: () => import('./map/map.module').then((m) => m.MapModule),
  },
  {
    path: 'authentication',
    loadChildren: () => import('./authentication/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: '**',
    redirectTo: 'admin/unauthorized', // Or a 404 component
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
